import { io, type Socket } from 'socket.io-client';

import { WS_URL } from '~/config/environment';
import { getLocalStorageItem } from '~/utils/local-storage';

let socketInstance: Socket | null = null;

export function getSocketInstance(): Socket {
  if (!socketInstance) {
    const token = getLocalStorageItem('access_token');
    socketInstance = io(WS_URL, {
      auth: {
        token,
      },
      autoConnect: false,
      transports: ['websocket'],
    });
    // retry the socket connection when disconnected
    socketInstance.on('disconnect', () => {
      socketInstance?.connect();
    });
  }
  return socketInstance;
}
